import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	none: {
		id: 'issue-table.common.fields.common.tags.none',
		defaultMessage: 'None',
		description: 'Text of message shown when there are no tags to show',
	},
});
